// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ImageMediumFragmentDoc } from '../imageMedium.fragment.generated';
export const ComponentRoundedImageFragmentDoc = gql`
    fragment componentRoundedImage on ComponentRoundedImage {
  backgroundColor
  backgroundImageColor
  backgroundImage {
    ...imageMedium
  }
  roundedImage {
    ...imageMedium
  }
}
    ${ImageMediumFragmentDoc}`;